const core = {
    palette: {
        common: {
            blue: '#085fe5',
            anchorBlue: '#0f71e2',
            hoverBlue: '#3B82EA',
            activeBlue: '#B9D8F9',
            transparent: 'transparent',
            white: '#fff',
            grey: '#f7f9fb',
            grey2: '#7f8fa4',
            grey3: '#9fa9ba',
            grey4: '#e6eaee',
            grey5: '#888',
            activeGrey: '#e7edf1',
            lightGrey: '#dddddd',
            errorRed: '#e34c4c',
            green: '#53D86A',
            faintBlack: '#1e232d',
        },
    },

    gradients: {
        red: 'linear-gradient(309deg, #f2dc7f, #c7345f 46%, #63047c)',
        purple: 'linear-gradient(232deg, #3023ae, #c86dd7)',
        blue: 'linear-gradient(308deg, #20cefa, #6a24aa)',
        green: 'linear-gradient(299deg, #f2fdb0, #1cafc6 42%, #020e50)',
    },

    typography: {
        fontFamily: '"Circular Std Book", Helvetica, Arial, sans-serif',
    },

    border: {
        borderRadius: 4,
    },

    zIndex: {
        dropDownMenu: 1600,
    },
}

const theme = {
    ...core,
    button: {
        common: {
            border: '1px solid',
            borderRadius: core.border.borderRadius,
            textTransform: 'none',
            minWidth: 'auto',
        },

        solid: {
            color: core.palette.common.white,
            background: core.palette.common.blue,
            borderColor: core.palette.common.blue,
            hover: {
                background: core.palette.common.hoverBlue,
                borderColor: core.palette.common.hoverBlue,
            },
            active: {
                background: core.palette.common.activeBlue,
            },
        },

        white: {
            color: core.palette.common.blue,
            background: core.palette.common.white,
            borderColor: core.palette.common.blue,
            hover: {
                background: core.palette.common.grey,
            },
            active: {
                background: core.palette.common.activeGrey,
            },
        },

        transparent: {
            color: core.palette.common.blue,
            background: core.palette.common.transparent,
            borderColor: core.palette.common.blue,
            hover: {
                background: core.palette.common.grey,
            },
            active: {
                background: core.palette.common.activeGrey,
            },
        },
    },

    fieldInput: {
        common: {
            fontSize: 14,
            outline: 'none',
            border: 'none',
            '&::placeholder': {
                color: core.palette.common.grey2,
            },
        },

        errorMessage: {
            color: core.palette.common.errorRed,
            fontSize: 10,
            padding: '3px 5px',
        },
    },

    panel: {
        ...core.border,
        backgroundColor: core.palette.common.white,
        boxShadow: '0 6px 14px 0 rgba(0, 0, 0, 0.1)',
    },
}

export default theme
